(() => {
  const locale = document.documentElement.lang || 'en';
  const options = {useGrouping: 'always', maximumFractionDigits: 20};
  const formatter = new Intl.NumberFormat(locale, options);
  const decimals = new Map();
  const formatDecimal = raw => {
    const precision = raw.split(/[.,]/)[1].length;
    if (!decimals.has(precision)) decimals.set(precision, new Intl.NumberFormat(locale, {...options, minimumFractionDigits: precision}));
    return decimals.get(precision).format(Number(raw.replace(',', '.')));
  };
  const units = '(?:mg|ml|kg|g|µg|μg|mcg)\\b';
  const grouped = new RegExp('(?<![\\p{L}\\p{N}.,\u0027’])([1-9]\\d{0,2}(?:[ \\u00a0\\u202f]\\d{3})+)(?=\\s*'+units+')','gu');
  const ungrouped = new RegExp('(?<![\\p{L}\\p{N}.,\u0027’])(\\d{4,})(?=\\s*(?:[–−-]\\s*\\d[\\d., \\u00a0\\u202f]*)?\\s*'+units+')','gu');
  const fraction = new RegExp('(?<![\\p{L}\\p{N}.,\u0027’])(\\d{1,3}[.,]\\d{1,2})(?=\\s*(?:%|'+units+'))','gu');
  const normalize = text => text
    .replace(grouped, raw => formatter.format(Number(raw.replace(/[ \u00a0\u202f]/g,''))))
    .replace(ungrouped, raw => formatter.format(Number(raw)))
    .replace(fraction, formatDecimal);
  window.fsNumberFormat = {format: value => formatter.format(value), normalize};
  const excluded = 'script,style,textarea,input,option:not([value]),code,pre,[contenteditable="true"],[data-number-format="off"]';
  const update = node => {
    if (!node.parentElement || node.parentElement.closest(excluded)) return;
    const value = normalize(node.nodeValue);
    if (value !== node.nodeValue) node.nodeValue = value;
  };
  const scan = node => {
    if (node.nodeType === Node.TEXT_NODE) {update(node);return;}
    if (node.nodeType !== Node.ELEMENT_NODE || node.matches(excluded)) return;
    const walker = document.createTreeWalker(node,NodeFilter.SHOW_TEXT);
    while(walker.nextNode()) update(walker.currentNode);
  };
  const start = () => {
    scan(document.body);
    new MutationObserver(records => records.forEach(record => {
      if(record.type === 'characterData') update(record.target);
      else record.addedNodes.forEach(scan);
    })).observe(document.body,{subtree:true,childList:true,characterData:true});
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
